import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const StayPictogram = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M2.40001 2.5C1.93735 2.5 1.56001 2.87061 1.56001 3.325V7.12344C1.92313 6.81406 2.38251 6.56377 2.96001 6.36719V5.25C2.96001 4.51846 4.23204 4.425 5.34 4.425C6.44797 4.425 7.72 4.51846 7.72 5.25V5.8C7.81406 5.79893 7.90375 5.8 8 5.8C8.09625 5.8 8.18594 5.79893 8.28 5.8V5.25C8.28 4.51846 9.55203 4.425 10.66 4.425C11.768 4.425 13.04 4.51846 13.04 5.25V6.35859C13.6164 6.5541 14.0736 6.80977 14.44 7.12344V3.325C14.44 2.87061 14.0626 2.5 13.6 2.5H2.40001ZM8 6.35C2.65376 6.35 0.995634 7.32109 1.00001 9.925H15C15.0044 7.30391 13.3462 6.35 8 6.35ZM1.00001 10.475V13.5H2.96001V12.4C2.96001 12.0047 3.11751 11.85 3.52001 11.85H12.48C12.8825 11.85 13.04 12.0047 13.04 12.4V13.5H15V10.475H1.00001Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { StayPictogram };